import { render, staticRenderFns } from "./UcEmployeeList.yaml?vue&type=template&id=f73b88c6&component"
import script from "./UcEmployeeList.yaml?vue&type=script&lang=ts&component"
export * from "./UcEmployeeList.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports